/**
 * Role UUIDs returned in the `roles` array of GET /companyadmins rows.
 * Mirrors ApiUser.ROLE_* in paydays-api (pubapi/common/auth.py).
 */

import i18n from '@/i18n';

export const COMPANY_ADMIN_ROLE_ID = '2cbea343-d131-49ba-bb54-b1790c584dbc';
export const RECOGNITION_ADMIN_ROLE_ID = 'b69fb356-586d-445e-ae75-1bb13760c6a2';
export const RECOGNITION_VIEWER_ROLE_ID = '4abb464a-b216-495d-8a03-11c53401c2ea';

const roleIds = user => (user?.roles || []).map(role => String(role).toLowerCase());

// A user holding BOTH roles is a full admin (e.g. promoted later) — only
// rows with the recognition role and no company-admin role are scoped.
export const isRecognitionOnlyAdminRow = user => {
  const roles = roleIds(user);
  return roles.includes(RECOGNITION_ADMIN_ROLE_ID) && !roles.includes(COMPANY_ADMIN_ROLE_ID);
};

// The write scope wins where a user somehow holds both recognition roles, so
// the label never understates their access.
export const isRecognitionViewerAdminRow = user => {
  const roles = roleIds(user);
  return (
    roles.includes(RECOGNITION_VIEWER_ROLE_ID) &&
    !roles.includes(RECOGNITION_ADMIN_ROLE_ID) &&
    !roles.includes(COMPANY_ADMIN_ROLE_ID)
  );
};

// The `role` value POST/DELETE /companyadmins expects for a scoped row, or
// undefined for a full admin (the API defaults to company_admin).
export const scopedAdminRoleName = user => {
  if (isRecognitionOnlyAdminRow(user)) {
    return 'recognition_admin';
  }
  if (isRecognitionViewerAdminRow(user)) {
    return 'recognition_viewer';
  }
  return undefined;
};

// Deliberately separate from admins.add.adminRoleOptions.* (the Add Admin
// dropdown wording) — recognition's copy for that dropdown, kept intact here.
export const adminAccessLabel = user => {
  if (isRecognitionOnlyAdminRow(user)) {
    return i18n.t('usersList.accessValues.recognitionOnly');
  }
  if (isRecognitionViewerAdminRow(user)) {
    return i18n.t('usersList.accessValues.recognitionViewer');
  }
  return i18n.t('usersList.accessValues.fullAccess');
};
